// src/app/modules/kumariRemitIpo/redux/reducer.ts
import {KumariRemitIpoState} from '../Model'
import {
  KRI_CIF_LOOKUP_REQUEST, KRI_CIF_LOOKUP_SUCCESS, KRI_CIF_LOOKUP_FAILURE, KRI_CIF_LOOKUP_RESET,
  KRI_FETCH_LIST_REQUEST, KRI_FETCH_LIST_SUCCESS, KRI_FETCH_LIST_FAILURE,
  KRI_SUBMIT_REQUEST, KRI_SUBMIT_SUCCESS, KRI_SUBMIT_FAILURE,
  KRI_FETCH_CASE_REQUEST, KRI_FETCH_CASE_SUCCESS, KRI_FETCH_CASE_FAILURE,
  KRI_CHECKER_ACTION_REQUEST, KRI_CHECKER_ACTION_SUCCESS, KRI_CHECKER_ACTION_FAILURE,
} from './constants'

const initialState: KumariRemitIpoState = {
  cifLoading: false, cifData: null, cifError: null, duplicateExists: false,
  applications: [], listLoading: false, listTotal: 0,
  currentCase: null, caseLoading: false,
  actionLoading: false, actionError: null,
}

export const reducer = (state = initialState, action: any): KumariRemitIpoState => {
  switch (action.type) {
    case KRI_CIF_LOOKUP_REQUEST:
      return {...state, cifLoading: true, cifData: null, cifError: null, duplicateExists: false}
    case KRI_CIF_LOOKUP_SUCCESS:
      return {...state, cifLoading: false, cifData: action.payload, duplicateExists: action.payload.has_remit_ipo_account}
    case KRI_CIF_LOOKUP_FAILURE:
      return {...state, cifLoading: false, cifError: action.payload}
    case KRI_CIF_LOOKUP_RESET:
      return {...state, cifData: null, cifError: null, duplicateExists: false}

    case KRI_FETCH_LIST_REQUEST: return {...state, listLoading: true}
    case KRI_FETCH_LIST_SUCCESS:
      return {...state, listLoading: false, applications: action.payload.data, listTotal: action.payload.total}
    case KRI_FETCH_LIST_FAILURE: return {...state, listLoading: false}

    case KRI_SUBMIT_REQUEST: return {...state, actionLoading: true, actionError: null}
    case KRI_SUBMIT_SUCCESS: return {...state, actionLoading: false}
    case KRI_SUBMIT_FAILURE: return {...state, actionLoading: false, actionError: action.payload}

    case KRI_FETCH_CASE_REQUEST: return {...state, caseLoading: true, currentCase: null}
    case KRI_FETCH_CASE_SUCCESS: return {...state, caseLoading: false, currentCase: action.payload}
    case KRI_FETCH_CASE_FAILURE: return {...state, caseLoading: false}

    case KRI_CHECKER_ACTION_REQUEST: return {...state, actionLoading: true, actionError: null}
    case KRI_CHECKER_ACTION_SUCCESS: return {...state, actionLoading: false}
    case KRI_CHECKER_ACTION_FAILURE: return {...state, actionLoading: false, actionError: action.payload}

    default: return state
  }
}
